import React, { useState, useRef } from "react";
import Navbar from "../components/navbar";
import Footer from "../components/Footer";
import "../about/SplashPdfViewer.css";
import CTAButton from "../components/sticky-button";
import PageHeader from "../about/PageHeader";
import BrochureForm from "../components/brochure-form";

const Newsletter = () => {
  // Reference for scrolling to the top of the content
  const topRef = useRef(null);
  const [showForm, setShowForm] = useState(false);

 const pdfList = [
    { id: 1, title: "News Letter-Apr-Jun 2025", src: "/pdf/Life/Newsletter/News-Letter-2025-AMJ-1.pdf", isWeb: false },
    { id: 2, title: "News Letter-Jan-Mar 2025", src: "/pdf/Life/Newsletter/News-Letter-2025-JFM-Final.pdf", isWeb: false },
    { id: 3, title: "News Letter-Oct-Dec 2024", src: "/pdf/Life/Newsletter/News-Letter-2024-OND.pdf", isWeb: false },
    { id: 4, title: "News Letter-Jul-Sept 2024", src: "/pdf/Life/Newsletter/News-Letter-2024-JAS-Low.pdf", isWeb: false },
    { id: 5, title: "News Letter-Apr-Jun 2024", src: "/pdf/Life/Newsletter/News-Letter-2024-AMJ.pdf", isWeb: false },
    { id: 6, title: "News Letter-Jan-Mar 2024", src: "/pdf/Life/Newsletter/News-Letter-2024-JFM.pdf", isWeb: false },
    { id: 7, title: "News Letter-Oct-Dec 2023", src: "/pdf/Life/Newsletter/News-Letter-2023-OND-3.pdf", isWeb: false },
    { id: 8, title: "News Letter-Jul-Sept 2023", src: "/pdf/Life/Newsletter/News-Letter-2023-JAS-3-1.pdf", isWeb: false },
    { id: 9, title: "News Letter-Apr-Jun 2023", src: "/pdf/Life/Newsletter/News-Letter-2023-AMJ.pdf", isWeb: false },
    { id: 10, title: "News Letter-Jan-Mar 2023", src: "/pdf/Life/Newsletter/News-Letter-2023-JFM.pdf", isWeb: false },
    { id: 11, title: "News Letter-Oct-Dec 2022", src: "/pdf/Life/Newsletter/News-Letter-2022-OND.pdf", isWeb: false },
    { id: 12, title: "News Letter-Jul-Sept 2022", src: "/pdf/Life/Newsletter/News-Letter-2022-JAS.pdf", isWeb: false },
    { id: 13, title: "News Letter-Apr-Jun 2022", src: "/pdf/Life/Newsletter/News-Letter-2022-AMJ.pdf", isWeb: false },
    { id: 14, title: "News Letter-Jan-Mar 2022", src: "/pdf/Life/Newsletter/News-Letter-2022-JFM.pdf", isWeb: false },
    { id: 15, title: "News Letter-Oct-Dec 2021", src: "/pdf/Life/Newsletter/News-Letter-2021-OND-2.pdf", isWeb: false },
    { id: 16, title: "News Letter-Jul-Sep 2021", src: "/pdf/Life/Newsletter/News-Letter-2021-JAS.pdf", isWeb: false },
    { id: 17, title: "News Letter-Apr-Jun 2021", src: "/pdf/Life/Newsletter/News-Letter-2021-AMJ.pdf", isWeb: false },
    { id: 18, title: "News Letter-Jan-Mar 2021", src: "/pdf/Life/Newsletter/News-Letter-2021-JFM-1.pdf", isWeb: false },
    { id: 19, title: "News Letter-Oct-Dec 2020", src: "/pdf/Life/Newsletter/News-Letter-2020-4-OND.pdf", isWeb: false },
    { id: 20, title: "News Letter-Jul-Sep 2020", src: "/pdf/Life/Newsletter/News-Letter-2020-3-JAS-Final.pdf", isWeb: false },
    { id: 21, title: "News Letter-Apr-Jun 2020", src: "/pdf/Life/Newsletter/News-Letter-2020-2-AMJ.pdf", isWeb: false },
    { id: 22, title: "News Letter-Jan-Mar 2020", src: "/pdf/Life/Newsletter/News-Letter-2020-1-JFM.pdf", isWeb: false },
    { id: 23, title: "News Letter-Oct-Dec 2019", src: "/pdf/Life/Newsletter/News-Letter-2019-OND.pdf", isWeb: false }
  ];

  const [activePdf, setActivePdf] = useState(pdfList[0]);

  const handlePdfSelection = (pdf) => {
    // Scroll the specific element into view smoothly
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    // Fallback for window scrolling
    window.scrollTo({ top: 0, behavior: "smooth" });

    if (pdf.isWeb) {
      window.open(pdf.src, "_blank");
    } else {
      setActivePdf(pdf);
    }
  };

  return (
    <>
      <Navbar setShowForm={setShowForm} />
      {showForm && <BrochureForm setShowForm={setShowForm} />}
      <CTAButton />

      <div className="spv-modern-portal">
        {/* Attach the ref to the header */}
        <div ref={topRef}>
          <PageHeader 
            title="Newsletters" 
            crumbs={[{ label: 'Home', href: '/' }, { label: 'Newsletters' }]} 
          />
        </div>

        <div className="spv-main-content">
          <aside className="spv-sidebar-modern">
            <div className="spv-sidebar-header-text">NEWSLETTERS</div>
            <nav className="spv-nav-group">
              {pdfList.map((pdf) => (
                <button
                  key={pdf.id}
                  className={`spv-nav-card ${activePdf.id === pdf.id ? "is-active" : ""}`}
                  onClick={() => handlePdfSelection(pdf)}
                >
                  <div className="spv-card-content">
                    <img 
                      src={pdf.isWeb ? "/images/icons/browser.svg" : "/images/icons/pdf.svg"} 
                      alt="icon" 
                      className="spv-doc-icon-img" 
                    />
                    <span className="spv-card-text">{pdf.title}</span>
                    <img 
                      src="/images/icons/move.webp" 
                      alt="arrow icon" 
                      className="spv-doc-icon-img" 
                    />
                  </div>
                </button>
              ))}
            </nav>
          </aside>

          <main className="spv-viewer-area" key={activePdf.id}>
            <header className="spv-viewer-topbar">
              <div className="spv-info-stack">
                <h2 className="spv-doc-title">{activePdf.title}</h2>
              </div>
              <div className="spv-action-group">
                <button className="spv-btn spv-btn-outline" onClick={() => window.open(activePdf.src, "_blank")}>
                  Full Screen
                </button>
              </div>
            </header>

            <div className="spv-pdf-viewport">
              <div className="spv-pdf-card no-select">
                <iframe
                  src={`${activePdf.src}#toolbar=0&navpanes=0&scrollbar=0`}
                  className="spv-iframe-content secure-frame"
                  title="Newsletter Viewer"
                  onContextMenu={(e) => e.preventDefault()}
                />
              </div>
            </div>
          </main>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Newsletter;